import Vue from 'vue'
import './assets/font/iconfont.css'
import './assets/css/bootstrap.scss'
import './assets/css/app.scss'
import App from './App.vue'


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
